import styled from "styled-components";
import colours from "styles/colours";

export const ExpandButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  margin-left: 5px;
  font-weight: bold;
  color: black;

  &:hover {
    color: ${colours.elexonBlue};
  }
`;
